import { render } from "./ExportDialog.vue?vue&type=template&id=6b649552"
import script from "./ExportDialog.vue?vue&type=script&lang=js"
export * from "./ExportDialog.vue?vue&type=script&lang=js"

import "./ExportDialog.vue?vue&type=style&index=0&id=6b649552&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__